module.exports = __webpack_public_path__ + "static/img/083.c9f7aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/083.png
// module id = RK1V
// module chunks = 0